export default __webpack_public_path__ + "static/Cafe24Danjunghae.subset-f6e7a0fcca784ff21c86df869f915fca.woff";